export abstract class BattleComponent {
  abstract show(): void
  abstract hide(): void
}
